import { render, staticRenderFns } from "./MediaCategoryThemesTab.vue?vue&type=template&id=1da4b49d"
import script from "./MediaCategoryThemesTab.vue?vue&type=script&lang=js"
export * from "./MediaCategoryThemesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports